/*
    Merrid Controls. Wszelkie prawa zastrzeżone.
    Plik zawiera kody Źródłowe będące własnością firmy Merrid Controls.
    Nie wolno ich rozpowszechniać w całości lub fragmentach bez wyraźnej zgody właściciela.
*/


import React, {useContext, useEffect, useRef, useState} from "react";

import {useDispatch} from "react-redux";
import CHANGE_API_REQUEST_STATUS_ACTION from "@Actions/Interface/ChangeApiRequestStatus";
import {useTypedSelector} from "@Services/Hooks/UseTypedSelector";

import LOGGED_USER_INTERFACE from "@Store/Interfaces/Authentication/User";


import ApplicationApiContext from "@Contexts/Api";


import {Location} from "history";


import {Redirect} from "react-router-dom";


import {Button, Col, Row} from "react-bootstrap";


import WarningMessageComponent from "@Components/UI/Communicates/Messages/Warning";
import ErrorMessageComponent from "@Components/UI/Communicates/Messages/Error";


import BlockContentContainerComponent from "@Components/UI/Containers/Block";
import BlockContentHeaderComponent from "@Components/UI/Containers/Block/Header";

import MonitoryNoteInformationComponent from "@UIPages/Authenticated/MonitoryNotes/_Parts/NoteInformation";
import MonitoryNoteDispositionsComponent from "@UIPages/Authenticated/MonitoryNotes/_Parts/Dispositions";
import MonitoryNoteCompartmentsComponent from "@UIPages/Authenticated/MonitoryNotes/_Parts/Compartments";


import PETROL_TERMINAL_IMAGE from "@Images/petrol_terminal.jpg";
import {HTTP_ERROR_RESPONSE_INTERFACE} from "@Services/Interfaces/Http/Response/Error";
import MONITORY_NOTE_INTERFACE from "@Services/Application/Interfaces/MonitoryNotes/MonitoryNote";
import ERROR_SYSTEM_MESSAGE_INTERFACE from "@Services/Application/Interfaces/_Messages/Errors";
import MonitoryNotePictureComponent from "@UIPages/Authenticated/MonitoryNotes/_Parts/Picture";
import VEHICLE_INTERFACE from "@Services/Application/Interfaces/Vehicles/Vehicle";
import BlockContentPictureComponent from "@Components/UI/Containers/Block/Picture";
import DELETE_MONITORY_NOTE_REQUEST_HANDLER from "@Services/Application/Requests/MonitoryNotes/Delete";
import MonitoryNoteScheduleWindowComponent from "@UIPages/Authenticated/MonitoryNotes/_Parts/ScheduleWindow";
import AUTHORIZATION_TOKEN_INTERFACE from "@Reducers/Api/RequestToken";
import REST_API_REQUEST from "@Services/Utilities/Requests";
import CHANGE_API_REQUEST_TOKEN_ACTION from "@Actions/Api/ChangeApiRequestTokenValue";
import prepareRestApiRequestToken from "@Services/Utilities/RequestToken/Prepare";
import MainContentLoaderComponent from "@Components/UI/Loaders/MainContent";
import RestApiRequestLoaderComponent from "@Components/UI/Loaders/ApiRequest";



interface LocationInterface {
    from: {pathname: string};
    monitoryNoteId: string | number;
    terminalName: string;
}

type DeleteMonitoryNotePageProps = {location: any};


const DEFAULT_REQUEST_HEADERS: HeadersInit = {"content-Type": "application/json"};


export const DeleteMonitoryNotePageComponent: React.FC<DeleteMonitoryNotePageProps> = ({
    location
}): JSX.Element | null => {


    const MONITORY_NOTE_ID = location.state.monitoryNoteId;


    /** @const Global State Actions Dispatcher */
    const DISPATCHER = useDispatch();


    const COMPONENT_REF: React.Ref<HTMLDivElement | null> = useRef(null);


    /** @const {object} INTERFACE_DATA - Application State Store Interface Data */
    const INTERFACE_DATA:ReturnType<any> = useTypedSelector(
        (state) => state.interface
    );

    /** @const {boolean} REST_API_REQUEST_STATUS - Application Global State Rest Api Request Status */
    const REST_API_REQUEST_STATUS: boolean = INTERFACE_DATA?.apiRequestStatus || false;

    /** @type {UserInterface | null} Application Logged User (from Global Store Object */
    const LOGGED_USER: LOGGED_USER_INTERFACE = useTypedSelector(
        (state):ReturnType<any> => state?.authentication
    )?.loggedUser || null;

    /** @const {string} Global Rest Api Root URL Address */
    const REST_API_URL = useContext(ApplicationApiContext)?.API_ROOT_URL || null;


    /** @const {object} REST_API_DATA - Application State Store Rest Api Data */
    const REST_API_DATA:ReturnType<any> = useTypedSelector(
        (state) => state.api
    );

    /** @const {} REST_API_REQUEST_TOKEN - Application Rest Api Request Token */
    const REST_API_REQUEST_TOKEN: AUTHORIZATION_TOKEN_INTERFACE = REST_API_DATA?.requestToken || null;


    const [MONITORY_NOTE_LOADED_STATUS, SET_MONITORY_NOTE_LOADED_STATUS] = useState<boolean>(false);


    const [MONITORY_NOTE, SET_MONITORY_NOTE] = useState<MONITORY_NOTE_INTERFACE | null>(null);
    const [MONITORY_NOTE_ERROR, SET_MONITORY_NOTE_ERROR] = useState<ERROR_SYSTEM_MESSAGE_INTERFACE | null>(null);

    const [MONITORY_NOTE_SUBMIT_STATUS, SET_MONITORY_NOTE_SUBMIT_STATUS] = useState<any>(false);

    const [SCHEDULE_WINDOW_LOADED_STATUS, SET_SCHEDULE_WINDOW_LOADED_STATUS] = useState<boolean>(false);

    useEffect(() => {

        if (!MONITORY_NOTE_ID) return;

        if (!!MONITORY_NOTE) return;

        const MONITORY_NOTE_API_URL: string = REST_API_URL + "/TransportNotification/Get";

        interface MONITORY_NOTE_REQUEST_DATA_INTERFACE {
            UserId: number | string,
            TransportNotificationNo: number | string
        }

        const MONITORY_NOTE_REQUEST_DATA: MONITORY_NOTE_REQUEST_DATA_INTERFACE = {
            UserId: LOGGED_USER?.userID, // Logged User ID
            TransportNotificationNo: MONITORY_NOTE_ID // Monitory Note ID
        };

        interface MonitoryNoteResponseInterface {
            ProcessStartDate?: string; // DateTime string for Process Start
            MinDelayForSubmit?: number; // Minutes before Process Start
            Compartments?: any // List of Monitory Note Vehicle Compartments
        }

        const GET_MONITORY_NOTE = async (): Promise<void | Function> => {

            DISPATCHER(CHANGE_API_REQUEST_STATUS_ACTION(true)); // Set Status to true

            try {

                const MONITORY_NOTE_RESPONSE = await REST_API_REQUEST(
                    MONITORY_NOTE_API_URL,
                    MONITORY_NOTE_REQUEST_DATA,
                    REST_API_REQUEST_TOKEN
                );

                if (MONITORY_NOTE_RESPONSE.status === 200) {

                    const CONTENT: MonitoryNoteResponseInterface = await MONITORY_NOTE_RESPONSE.json(); // JSON Object
                    SET_MONITORY_NOTE(CONTENT);

                } else {

                    const CONTENT: HTTP_ERROR_RESPONSE_INTERFACE = await MONITORY_NOTE_RESPONSE.json();
                    SET_MONITORY_NOTE_ERROR({ErrorCode: MONITORY_NOTE_RESPONSE.status, UserMessage: CONTENT.UserMessage}); // Set Monitory Note Page Error

                }
            } catch (e) { // Error Appeared
                SET_MONITORY_NOTE_ERROR({ErrorCode: 500, UserMessage: "Wystąpił nieokreślony błąd - skontaktuj się z CDOK"}); // Set Monitory Note Page Error
            }

            DISPATCHER(CHANGE_API_REQUEST_STATUS_ACTION(false));

        };

        GET_MONITORY_NOTE();

    }, [MONITORY_NOTE_ID]);


    const [VEHICLES_LIST, SET_VEHICLES_LIST] = useState<VEHICLE_INTERFACE[] | null>(null);
    const [VEHICLES_LIST_ERROR, SET_VEHICLES_LIST_ERROR] = useState<ERROR_SYSTEM_MESSAGE_INTERFACE | null>(null);

    useEffect(() => {

        if (!MONITORY_NOTE) return;

        if (VEHICLES_LIST) return;

        const VEHICLES_LIST_API_URL = REST_API_URL + "/Vehicle/List";

        const VEHICLES_LIST_REQUEST_DATA = {
            UserId: LOGGED_USER?.userID,
            Mode: "A",
            Favourite: false
        };

        const GET_VEHICLES_LIST = async () => {

            DISPATCHER(CHANGE_API_REQUEST_STATUS_ACTION(true));

            try {

                const VEHICLES_RESPONSE = await REST_API_REQUEST(
                    VEHICLES_LIST_API_URL,
                    VEHICLES_LIST_REQUEST_DATA,
                    REST_API_REQUEST_TOKEN
                );

                if (VEHICLES_RESPONSE.status === 200) {

                    const CONTENT: string = await VEHICLES_RESPONSE.text();
                    SET_VEHICLES_LIST(CONTENT.trim() ? JSON.parse(CONTENT)?.Vehicles : []);

                } else {
                    const CONTENT: HTTP_ERROR_RESPONSE_INTERFACE = await VEHICLES_RESPONSE.json();
                    SET_VEHICLES_LIST_ERROR({ErrorCode: VEHICLES_RESPONSE.status, UserMessage: CONTENT.UserMessage});
                }

            } catch (e) {
                SET_VEHICLES_LIST_ERROR({ErrorCode: 500, UserMessage: "Wystąpił nieokreślony błąd - skontaktuj się z CDOK"});
            }

            DISPATCHER(CHANGE_API_REQUEST_STATUS_ACTION(false));

        };

        GET_VEHICLES_LIST();

    }, [MONITORY_NOTE]);


    useEffect(() => {

        const COMPARTMENTS: any = {};

        if (!MONITORY_NOTE || !VEHICLES_LIST) return;

        if (!!MONITORY_NOTE?.CompartmentsList) return;

        const VEHICLES: any = Object.fromEntries(VEHICLES_LIST?.map((vehicle: VEHICLE_INTERFACE) => [vehicle.RegNo, vehicle]));

        const SELECTED_FRONT_VEHICLE = VEHICLES[MONITORY_NOTE?.FrontTruckRegNo || ""];
        const SELECTED_REAR_VEHICLE = VEHICLES[MONITORY_NOTE?.RearTruckRegNo || ""];

        if (SELECTED_FRONT_VEHICLE?.IsTank && SELECTED_FRONT_VEHICLE?.Compartments) {
            for (let compartment of SELECTED_FRONT_VEHICLE?.Compartments) {
                COMPARTMENTS[`F${compartment.CompPos}`] = {
                    product: null,
                    capacity: compartment.MaxVol,
                    DefaultVol: compartment.DefaultVol,
                    productCompartments: {},
                    compartmentVehicle: "F",
                    compartmentPosition: `F${compartment.CompPos}`
                };
            }
        }

        if (SELECTED_REAR_VEHICLE?.IsTank && SELECTED_REAR_VEHICLE?.Compartments) {
            for (let compartment of SELECTED_REAR_VEHICLE?.Compartments) {
                COMPARTMENTS[`R${compartment.CompPos}`] = {
                    product: null,
                    capacity: compartment.MaxVol,
                    DefaultVol: compartment.DefaultVol,
                    productCompartments: {},
                    compartmentVehicle: "R",
                    compartmentPosition: `R${compartment.CompPos}`
                };
            }
        }

        SET_MONITORY_NOTE({...MONITORY_NOTE, CompartmentsList: COMPARTMENTS});

    }, [MONITORY_NOTE?.FrontTruckRegNo, VEHICLES_LIST]);


    useEffect(() => {

        if (!MONITORY_NOTE?.CompartmentsList) return;

        const Products: any = {};

        if (MONITORY_NOTE?.Disps) {
            for (let disposition of MONITORY_NOTE?.Disps) {
                if (!disposition?.DispItems) continue;
                for (let product of disposition?.DispItems) {
                    const productID: string = disposition.DispNo + (product?.ProductMasterNo || product?.ProductShortName || "") + product.Pos;
                    Products[productID] = {...product, DispNo: disposition?.DispNo, productCompartments: {}};
                }
            }
        }

        if (MONITORY_NOTE?.Compartments) {
            for (let compartment of MONITORY_NOTE?.Compartments) {
                let compartmentVehicle: string = "";
                if (compartment?.TruckRegNo === MONITORY_NOTE?.FrontTruckRegNo) compartmentVehicle = "F";
                if (compartment?.TruckRegNo === MONITORY_NOTE?.RearTruckRegNo) compartmentVehicle = "R";
                if (!compartmentVehicle) continue;
                const COMPARTMENT_ID = `${compartmentVehicle}${compartment?.Pos}`;
                const COMPARTMENT = MONITORY_NOTE?.CompartmentsList[COMPARTMENT_ID];
                const PRODUCT: any = Products[`${compartment.DispNo}${compartment?.ProductMasterNo}${compartment.DispPos}` || ""] || null; // SZTYWNO!
                COMPARTMENT.product = PRODUCT;
                COMPARTMENT.productCapacity = compartment.Qty;
                if (PRODUCT) PRODUCT.productCompartments[COMPARTMENT_ID] = compartment.Qty;
            }
        }

        SET_MONITORY_NOTE({...MONITORY_NOTE, ProductsList: Products});

    }, [MONITORY_NOTE?.CompartmentsList]);


    const [MONITORY_NOTE_DETAILED_STATUS, SET_MONITORY_NOTE_DETAILED_STATUS] = useState<boolean | null>(null);

    useEffect(() => {
        if (!MONITORY_NOTE || !VEHICLES_LIST) return;
        SET_MONITORY_NOTE_DETAILED_STATUS(!!MONITORY_NOTE?.Compartments?.length);
    }, [MONITORY_NOTE?.ProductsList]);


    useEffect(() => {
        return () => {
            SET_MONITORY_NOTE(null);
            SET_MONITORY_NOTE_ERROR(null);
            SET_VEHICLES_LIST(null);
            SET_VEHICLES_LIST_ERROR(null);
            SET_MONITORY_NOTE_DETAILED_STATUS(null);
            SET_MONITORY_NOTE_LOADED_STATUS(false);
        };
    }, []);


    if (MONITORY_NOTE_SUBMIT_STATUS === true) return <Redirect to={"/awizacje"} />


    if (!MONITORY_NOTE_ID) return <Redirect to={"/awizacje"} />;


    if (MONITORY_NOTE_ERROR) return <ErrorMessageComponent messageText={MONITORY_NOTE_ERROR.UserMessage} />;


    if (!MONITORY_NOTE || !VEHICLES_LIST) return null;


    const VEHICLES: any = !VEHICLES_LIST ? {} : Object.fromEntries(VEHICLES_LIST?.map((vehicle: VEHICLE_INTERFACE) => [vehicle.RegNo, vehicle]));

    const SELECTED_FRONT_VEHICLE = VEHICLES[MONITORY_NOTE?.FrontTruckRegNo || ""];
    const SELECTED_REAR_VEHICLE = VEHICLES[MONITORY_NOTE?.FrontTruckRegNo || ""];


    const MODIFY_COMPARTMENT_HANDLER = (compartmentID: any, compartmentProductId: any, compartmentProductCapacity: number) => {

        const selectedCompartment = MONITORY_NOTE?.CompartmentsList[compartmentID];
        const selectedProduct = MONITORY_NOTE?.ProductsList[compartmentProductId];

        selectedCompartment.product = selectedProduct;
        selectedCompartment.productCapacity = compartmentProductCapacity;

        selectedProduct.productCompartments[compartmentID] = compartmentProductCapacity;

        SET_MONITORY_NOTE({
            ...MONITORY_NOTE,
            ProductsList: {...MONITORY_NOTE?.ProductsList, [compartmentProductId]: selectedProduct},
            CompartmentsList: {...MONITORY_NOTE?.CompartmentsList, [compartmentID]: selectedCompartment}
        });

    };

    const CLEAR_COMPARTMENT_HANDLER = (compartmentID: any, compartmentProductId: any) => {

        const selectedCompartment = MONITORY_NOTE?.CompartmentsList[compartmentID];
        const selectedProduct = MONITORY_NOTE?.ProductsList[compartmentProductId];

        selectedCompartment.product = null;
        delete selectedProduct?.productCompartments[compartmentID];

        SET_MONITORY_NOTE({
            ...MONITORY_NOTE,
            ProductsList: {...MONITORY_NOTE?.ProductsList, [compartmentProductId]: selectedProduct},
            CompartmentsList: {...MONITORY_NOTE?.CompartmentsList, [compartmentID]: selectedCompartment}
        });

    };


    const DELETE_MONITORY_NOTE_REQUEST = async () => {

        DISPATCHER(CHANGE_API_REQUEST_STATUS_ACTION(true));

        try {

            const MONITORY_NOTE_RESPONSE = await REST_API_REQUEST(
                `${REST_API_URL}/TransportNotification`,
                {UserId: LOGGED_USER.userID, TransportNotificationNo: MONITORY_NOTE_ID},
                REST_API_REQUEST_TOKEN,
                "DELETE"
            );

            if (MONITORY_NOTE_RESPONSE.status === 200 || MONITORY_NOTE_RESPONSE.status === 204) {
                SET_MONITORY_NOTE_SUBMIT_STATUS(true);
            } else {
                const ERROR_RESPONSE_CONTENT: HTTP_ERROR_RESPONSE_INTERFACE = await MONITORY_NOTE_RESPONSE.json();
                SET_MONITORY_NOTE_ERROR({UserMessage: ERROR_RESPONSE_CONTENT.UserMessage});
            }

        } catch (e) {
            SET_MONITORY_NOTE_ERROR({ErrorCode: 500, UserMessage: "Wystąpił nieokreślony błąd - skontaktuj się z CDOK"});
        }

        DISPATCHER(CHANGE_API_REQUEST_STATUS_ACTION(false));

    };


    const COMPONENT_DATA_LOADED_STATUS = !!MONITORY_NOTE && !!VEHICLES_LIST && !!MONITORY_NOTE?.CompartmentsList && !!MONITORY_NOTE?.ProductsList && MONITORY_NOTE_DETAILED_STATUS !== null;

    if (!COMPONENT_DATA_LOADED_STATUS) return null;


    return (
        <BlockContentContainerComponent forwardRef={COMPONENT_REF} cssClasses={"declare-arrival-page-component monitory-note-page-component"}>

            <BlockContentHeaderComponent headerText={`Odwołanie awizacji nr ${MONITORY_NOTE_ID}`} />

            {!MONITORY_NOTE_LOADED_STATUS && !REST_API_REQUEST_STATUS && <RestApiRequestLoaderComponent />}

            {!!MONITORY_NOTE_LOADED_STATUS &&
	        <Col xs={12} className={"monitory-note-message"}>
		        <span>{`Po odwołaniu awizacji nadal będziesz mógł skorzystać z dyspozycji z poziomu stacjonarnego kiosku MM`}</span>
	        </Col>
            }

            {!!MONITORY_NOTE_LOADED_STATUS &&
	        <Col xs={12} className={"declare-arrival-submit"}>
		        <Button variant={"primary"} onClick={DELETE_MONITORY_NOTE_REQUEST}>
			        <span>{`Odwołaj awizację`}</span>
		        </Button>
	        </Col>
            }

            <MonitoryNoteInformationComponent
                MONITORY_NOTE_PROCESS_TYPE={"submitting"}
                MONITORY_NOTE={MONITORY_NOTE}
                MONITORY_NOTE_DATA={{
                    VEHICLES: {
                        FRONT: SELECTED_FRONT_VEHICLE,
                        REAR: SELECTED_REAR_VEHICLE
                    }
                }}
                LOAD_CONTENT={MONITORY_NOTE_LOADED_STATUS}
            />

            {!!SCHEDULE_WINDOW_LOADED_STATUS &&
	        <MonitoryNoteDispositionsComponent
		        MONITORY_NOTE={MONITORY_NOTE}
		        MONITORY_NOTE_PROCESS_TYPE={"delete"}
		        LOAD_CONTENT={MONITORY_NOTE_LOADED_STATUS}
		        LOAD_CONTENT_HANDLER={SET_MONITORY_NOTE_LOADED_STATUS}
	        />
            }

            <MonitoryNoteScheduleWindowComponent
		        MONITORY_NOTE={MONITORY_NOTE}
		        MONITORY_NOTE_ACTION_TYPE={"delete"}
		        EDITABLE={false}
		        LOAD_CONTENT={MONITORY_NOTE_LOADED_STATUS}
                SCHEDULE_WINDOW_LOADED_STATUS_HANDLER={SET_SCHEDULE_WINDOW_LOADED_STATUS}
	        />

            <MonitoryNoteCompartmentsComponent
		        MONITORY_NOTE={MONITORY_NOTE}
		        MONITORY_NOTE_DETAILED_STATUS={MONITORY_NOTE_DETAILED_STATUS}
		        EDITABLE={false}
		        LOAD_CONTENT={MONITORY_NOTE_LOADED_STATUS}
	        />

        </BlockContentContainerComponent>
    );

};


export default DeleteMonitoryNotePageComponent;
